import { IconProp } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React from 'react'
import { NavLink } from 'react-router-dom'

interface IProps {
  href?: string
  icon: IconProp
  title: string
}

const NavBarItem: React.FC<IProps> = (props) => (
  <NavLink
    to={props.href ?? '/'}
    className={({ isActive }) => `mx-2 flex h-[60px] items-center rounded-md px-6 font-montserrat font-normal ${
      isActive
        ? 'bg-border-strong dark:bg-surface-chip-selected'
        : 'hover:bg-surface-info'
    }`}
  >
    {({ isActive }) => (
      <>
        <div className='flex w-[24px] h-[24px] items-center justify-center'>
          <FontAwesomeIcon
            icon={props.icon}
            size='lg'
            className={isActive
              ? 'text-icon-on-neutral-strong dark:text-icon-inverse'
              : 'text-icon-secondary'}
          />
        </div>

        <p className={`ml-4 ${isActive
          ? 'text-text-on-neutral-strong dark:text-text-inverse'
          : 'text-text-primary'}`}
        >
          {props.title}
        </p>
      </>
    )}
  </NavLink>
)

export default NavBarItem
